import { connect } from "react-redux";
import { IntlProvider, addLocaleData } from "react-intl";
import en from "react-intl/locale-data/en";
import ar from "react-intl/locale-data/ar";

addLocaleData([...en, ...ar]);

// This function will map the current redux state to the props for the component that it is "connected" to.
// When the state of the redux store changes, this function will be called, if the props that come out of
// this function are different, then the component that is wrapped is re-rendered.
function mapStateToProps(state) {
  const { lang, messages, locale } = state.locale;
  if (lang === "ar") {
    document.getElementsByTagName("html")[0].setAttribute("dir", "rtl");
    document.getElementsByTagName("html")[0].setAttribute("lang", "ar");
  } else {
    document.getElementsByTagName("html")[0].setAttribute("dir", "ltr");
    document.getElementsByTagName("html")[0].setAttribute("lang", "en");
  }
  window.zESettings = {
    webWidget: {
      position: {
        horizontal: lang === "ar" ? "left" : "right",
        vertical: "bottom"
      }
    }
  };
  return { lang, locale, messages };
}

export default connect(mapStateToProps)(IntlProvider);



// WEBPACK FOOTER //
// ./src/helper/ConnectedIntlProvider.js